/**
 * DEMO 역할 사용자를 위한 기능 설명 모달
 * 실제 기능 대신 설명만 보여줍니다.
 */

function DemoFeatureInfoModal({ isOpen, onClose, featureName, description, steps = [] }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          {/* 헤더 */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-gray-800">체험 모드 안내</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
              aria-label="닫기"
            >
              ×
            </button>
          </div>

          {/* 안내 메시지 */}
          <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>체험 모드</strong>에서는 실제 데이터를 생성하거나 수정할 수 없습니다.
              <br />
              아래 기능은 실제 사용 시 어떻게 작동하는지 설명드립니다.
            </p>
          </div>

          {/* 기능 이름 */}
          <div className="mb-4">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">{featureName}</h3>
            {description && (
              <p className="text-sm text-gray-600 mb-4">{description}</p>
            )}
          </div>

          {/* 사용 방법 */}
          {steps.length > 0 && (
            <div className="mb-6">
              <h4 className="text-md font-semibold text-gray-700 mb-3">사용 방법:</h4>
              <ol className="list-decimal list-inside space-y-2 text-sm text-gray-600">
                {steps.map((step, index) => (
                  <li key={index} className="pl-2">{step}</li>
                ))}
              </ol>
            </div>
          )}

          {/* 닫기 버튼 */}
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-orange-500 text-white rounded text-sm font-semibold hover:bg-orange-600"
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DemoFeatureInfoModal;

